// extracted by mini-css-extract-plugin
export default {"drop":"S7Ynx","demoLabel":"e_kY5","demo":"M5pjs","error":"t4Idu","card":"tim0_","demoIcon":"aBdb9","demoDescription":"tEFPQ","loading":"vf2HI","ldsRipple":"LKmAB"};